export class CalibrationDto {
    calibrationId: number;
    machineDescription: string;
    barcodeNo: string;
    instrument: string;
    instrumentMake: string;
    modelType: string;
    serialNo: string;
    calibrationRange: string;
    calibrationDueOn: Date;
    calibrationFrequency: string;
    location: string;
    isActive: boolean;
    updatedAt: Date | any;
    updatedUser: string;
    createdAt: Date | any;
    createdUser: string;
    versionFlag: number;
    filePath?:string;
    fileName?:string;
    plant?:string
    plantId?:number

    constructor(
        calibrationId: number,
        machineDescription: string,
        barcodeNo: string,
        instrument: string,
        instrumentMake: string,
        modelType: string,
        serialNo: string,
        calibrationRange: string,
        calibrationDueOn: Date,
        calibrationFrequency: string,
        location: string,
        isActive: boolean,
        updatedAt: Date | any,
        updatedUser: string,
        createdAt: Date | any,
        createdUser: string,
        versionFlag: number,
        filePath?:string,
    fileName?:string,
    plant?:string,
    plantId?:number
    ) {
        this.calibrationId = calibrationId;
        this.machineDescription = machineDescription;
        this.barcodeNo = barcodeNo;
        this.instrument = instrument;
        this.instrumentMake = instrumentMake;
        this.modelType = modelType;
        this.serialNo = serialNo;
        this.calibrationRange = calibrationRange;
        this.calibrationDueOn = calibrationDueOn;
        this.calibrationFrequency = calibrationFrequency;
        this.location = location;
        this.isActive = isActive;
        this.updatedAt = updatedAt;
        this.updatedUser = updatedUser;
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.versionFlag = versionFlag;
        this.filePath = filePath
        this.fileName =fileName
        this.plant = plant
        this.plantId = plantId
    }
}
